import { useAuditoriaAccesos } from '../hooks/useAuditoriaAccesos';

/**
 * Componente invisible que monta el hook de auditoría de accesos.
 * Debe colocarse dentro de BrowserRouter + AuthProvider.
 */
export function AccessTracker() {
  useAuditoriaAccesos();
  return null;
}
